import React, { useContext, useEffect, useState } from 'react';
import Context from '../context/context';
import { ArrowRight } from '@mui/icons-material';

let mouseInsideState = false
const ContextMenu = ({ id, visibleContext, setVisibleContext, order_type, seats, currentSeat }) => {

    const context = useContext(Context);
    const { switchTable } = context;
    const [visibleDropdown, setVisibleDropdown] = useState(null)

    useEffect(() => {
        seats && console.log(seats);
        return () => setVisibleDropdown(null);
    }, [seats])

    return <button
        className="context-menu"
        id={`context-menu-container-${id}`}
        onBlur={e => mouseInsideState === false && setVisibleContext({})}
        onMouseOver={e => mouseInsideState = true}
        onMouseLeave={e => mouseInsideState = false}
        style={{
            display: "flex",
            top: `${visibleContext?.elemProperties?.top + 20}px`,
            left: `${visibleContext?.elemProperties?.left - 80}px`
        }}
        autoFocus
    >
        {/* <button className="context-item" onClick={e => deleteOrder(id)}>Delete This Order</button> */}
        {order_type === 0 &&
            <button
                className="context-item context-dropdown-trigger"
                onMouseOver={e => { setVisibleDropdown(0); }}
                onMouseLeave={e => setVisibleDropdown(null)}
            >
                <div>Switch Table</div>
                <ArrowRight />
            </button>}

        {seats?.filter(seat => seat.color === "#4AC959")?.[0] &&
            <div
                id="seats-list"
                className={`context-dropdown ${visibleDropdown === 0 && "active"}`}
                onMouseEnter={e => setVisibleDropdown(0)}
                onMouseLeave={e => setVisibleDropdown(null)}
            >
                {
                    seats?.filter(seat => seat.color === "#4AC959")?.map(seat => {
                        return <div className="dropdown-item" id={seat.seat_uuid}
                            onClick={e => {
                                switchTable(currentSeat, seat.seat_uuid)
                                setVisibleContext({})
                            }}
                        >{seat.seat_name}
                        </div>
                    })
                }
            </div>}
    </button>
}

export default ContextMenu